import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, SubmissionError, reduxForm } from 'redux-form';

import { notify } from '@/actions/ui';
import Form from '@/components/Form';
import { Checkbox } from '@/components/FormAdapters';
import { reportProfileSaveFailure } from '@/profile/profileSaveFailure';
import { updateProfile } from '@/profile/store';

const SAVE_ERROR = 'An error occurred when updating your privacy settings.';

export class PrivacyForm extends PureComponent {
  static propTypes = {
    profileId: PropTypes.string,
    component: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    updateProfile: PropTypes.func,
    notify: PropTypes.func,
    reset: PropTypes.func,
    onReset: PropTypes.func,
  };

  handleSubmit = async (values: any) => {
    // @ts-expect-error TS(2339): Property 'profileId' does not exist on type 'Reado... Remove this comment to see the full error message
    const { profileId, updateProfile, onSubmit, notify } = this.props;

    try {
      await updateProfile({ id: profileId, ...values });
    } catch (err) {
      // SubmissionError, not a raw Error: redux-form resolves with its errors, so
      // neither EditDialog nor DeprecatedSaveForm reads the failure as a success.
      throw new SubmissionError({ _error: reportProfileSaveFailure(err, notify, SAVE_ERROR) });
    }

    if (onSubmit) onSubmit(values);
  };

  handleReset = () => {
    // @ts-expect-error TS(2339): Property 'reset' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reset, onReset } = this.props;
    reset();
    if (onReset) onReset();
  };

  render() {
    const {
      // @ts-expect-error TS(2339): Property 'component' does not exist on type 'Reado... Remove this comment to see the full error message
      component: Container = Form,
      // @ts-expect-error TS(2339): Property 'handleSubmit' does not exist on type 'Re... Remove this comment to see the full error message
      handleSubmit,
      // @ts-expect-error TS(2339): Property 'profile' does not exist on type 'Readonl... Remove this comment to see the full error message
      profile,
      ...other
    } = this.props;

    return (
      <Container onSubmit={handleSubmit(this.handleSubmit)} onReset={this.handleReset} {...other}>
        <Field
          type="checkbox"
          component={Checkbox}
          name="hide_profile"
          label="Keep my profile hidden"
        />
      </Container>
    );
  }
}

const WrappedPrivacyForm = reduxForm({
  form: 'expertPrivacy',
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'typeof PrivacyForm' is not assig... Remove this comment to see the full error message
})(PrivacyForm);

export default connect(
  (state, ownProps) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const profile = state.profiles.fullProfiles[ownProps.profileId];
    return {
      profile,
      initialValues: {
        hide_profile: profile.hide_profile,
      },
    };
  },
  {
    updateProfile,
    notify,
  }
)(WrappedPrivacyForm);
